import Vue from "vue";

export const log = {
  info: (message: string) => Vue.$log.info(message),
  error: (message: string) => Vue.$log.error(message)
};
